import { toast } from 'react-toastify';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { API_ENDPOINT } from '../constants';
import { fetchWrapper } from '../helpers';

import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import type { IFacility } from '../utils/types';

const name = 'facilities';
const initialState = createInitialState();
const reducers = createReducers();
// SAFETY: Legacy thunk action creators use the store dispatch result contract.
const extraActions = createExtraActions() as any;
const slice = createSlice({
  name,
  initialState,
  reducers,
  extraReducers: (builder: ActionReducerMapBuilder<FacilityState>) => createExtraReducers(builder),
});

export interface FacilityState {
  list: Array<IFacility>;
  error: any;
  loading: boolean;
}

function createInitialState(): FacilityState {
  return {
    list: [],
    loading: false,
    error: null,
  };
}

function createReducers() {
  return {};
}

function createExtraActions() {
  const baseUrl = `${API_ENDPOINT}/facilities`;

  return {
    getList: getList(),
    createFacility: createFacility(),
  };

  function getList() {
    return createAsyncThunk(`${name}/getList`, async ({ getAccessTokenSilently }: any) => {
      const response = await fetchWrapper.get({
        url: `${baseUrl}/`,
        getAccessTokenSilently,
      });
      return response;
    });
  }

  function createFacility() {
    return createAsyncThunk(
      `${name}/createFacility`,
      async ({ data, getAccessTokenSilently }: any) => {
        const response = await fetchWrapper.post(
          { url: `${baseUrl}/`, getAccessTokenSilently },
          data,
        );
        return response;
      },
    );
  }
}

function createExtraReducers(builder: ActionReducerMapBuilder<FacilityState>) {
  const { getList, createFacility } = extraActions;

  builder
    .addCase(getList.pending, (state: FacilityState) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(getList.fulfilled, (state: FacilityState, action: PayloadAction<IFacility[]>) => {
      state.list = action.payload;
      state.loading = false;
    })
    .addCase(getList.rejected, (state: FacilityState, action: any) => {
      state.list = [];
      state.error = action.error;
      state.loading = false;
    })
    // for facility post
    .addCase(createFacility.pending, (state: FacilityState) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(
      createFacility.fulfilled,
      (state: FacilityState, _action: PayloadAction<IFacility>) => {
        state.loading = false;
        toast.success('New facility Created');
      },
    )
    .addCase(createFacility.rejected, (state: FacilityState, action: any) => {
      state.error = action.error;
      state.loading = false;
      toast.error(state.error.message);
    });
}

export const facilityActions = { ...slice.actions, ...extraActions };
export const facilityReducer = slice.reducer;
